import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withTranslator } from '@wh/ui-translations';
import ThemeConsumer from '@sitebase/theme-context/es/ThemeConsumer';


import { getSpinnerProperties, getSpinnerColors, getPreset } from './spinner-tools';
import { category, makeOutfitParser, replaceValue } from '../outfit-parser';
import { getAllowedAttributes } from '../props-filters';
import outfitPropValidator from '../outfitPropValidator';
import propTypeClassName from '../propTypeClassName';
import translationContext from '../translationContext';
import uuid from '../uuid';

import * as style from './Spinner.style';

var defaultOutfit = 'primary';

var presetsList = ['primary'];
var colorsList = ['blue', 'green', 'yellow', 'white'];
var sizesList = ['tiny', 'small', 'normal'];
var parseOutfit = makeOutfitParser(category('presets', presetsList), category('colors', colorsList), category('sizes', sizesList));

var resolvePreset = function resolvePreset(outfit, theme) {
  var parsedOutfit = parseOutfit(outfit);

  var _parsedOutfit$get = parsedOutfit.get('presets'),
      _parsedOutfit$get2 = _slicedToArray(_parsedOutfit$get, 1),
      preset = _parsedOutfit$get2[0];

  return replaceValue(outfit, preset, getPreset(preset, theme));
};

var Spinner = function (_PureComponent) {
  _inherits(Spinner, _PureComponent);

  function Spinner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Spinner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Spinner.__proto__ || _Object$getPrototypeOf(Spinner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      id: null
    }, _this._renderSpinnerWithTheme = function (theme) {
      var id = _this.state.id;

      var _this$props = _this.props,
          t = _this$props.t,
          className = _this$props.className,
          outfit = _this$props.outfit,
          restProps = _objectWithoutProperties(_this$props, ['t', 'className', 'outfit']);

      var allowedAttributes = getAllowedAttributes(restProps);

      var resolvedOutfit = resolvePreset(defaultOutfit + ' ' + outfit, theme);
      var parsedOutfit = parseOutfit(resolvedOutfit);

      var _parsedOutfit$get3 = parsedOutfit.get('colors'),
          _parsedOutfit$get4 = _slicedToArray(_parsedOutfit$get3, 1),
          colorOutfit = _parsedOutfit$get4[0];

      var _parsedOutfit$get5 = parsedOutfit.get('sizes'),
          _parsedOutfit$get6 = _slicedToArray(_parsedOutfit$get5, 1),
          sizeOutfit = _parsedOutfit$get6[0];

      var _getSpinnerColors = getSpinnerColors(colorOutfit),
          disc = _getSpinnerColors.disc,
          glow = _getSpinnerColors.glow,
          cometStart = _getSpinnerColors.cometStart,
          cometEnd = _getSpinnerColors.cometEnd;

      var _getSpinnerProperties = getSpinnerProperties(sizeOutfit),
          size = _getSpinnerProperties.size,
          padding = _getSpinnerProperties.padding,
          borderWidth = _getSpinnerProperties.borderWidth,
          radius = _getSpinnerProperties.radius,
          canvasSize = _getSpinnerProperties.canvasSize,
          arcPath = _getSpinnerProperties.arcPath;

      return React.createElement(
        'div',
        _extends({
          role: 'alert',
          'aria-label': translationContext(t)('loading')
        }, allowedAttributes, {
          className: cx(style.spinnerWrapper, style.getDimensionsStyle(size), className)
        }),
        React.createElement(
          'svg',
          {
            className: cx(style.spinner, style.getDimensionsStyle(canvasSize), style.getAlignmentStyle(padding)),
            viewBox: '0 0 ' + canvasSize + ' ' + canvasSize,
            xmlns: 'http://www.w3.org/2000/svg'
          },
          React.createElement(
            'g',
            { className: 'currentLayer' },
            React.createElement('circle', {
              fill: 'none',
              stroke: disc,
              strokeWidth: borderWidth,
              opacity: '1',
              cx: canvasSize / 2,
              cy: canvasSize / 2,
              r: radius
            }),
            React.createElement('path', {
              fill: 'none',
              stroke: 'url(#' + id + '-glow)',
              strokeWidth: borderWidth,
              opacity: '1',
              d: arcPath,
              filter: 'url(#' + id + '-blur)'
            }),
            React.createElement('path', {
              fill: 'none',
              stroke: 'url(#' + id + '-spinner)',
              strokeWidth: borderWidth,
              strokeLinecap: 'round',
              opacity: '1',
              d: arcPath
            })
          ),
          React.createElement(
            'defs',
            null,
            React.createElement(
              'linearGradient',
              { id: id + '-glow', x1: '0%', y1: '0%', x2: '0%', y2: '100%' },
              React.createElement('stop', { offset: '0%', stopColor: glow, stopOpacity: '1' }),
              React.createElement('stop', { offset: '100%', stopColor: glow, stopOpacity: '0' })
            ),
            React.createElement(
              'linearGradient',
              { id: id + '-spinner', x1: '0%', y1: '0%', x2: '0%', y2: '100%' },
              React.createElement('stop', { offset: '0%', stopColor: cometStart, stopOpacity: '1' }),
              React.createElement('stop', { offset: '100%', stopColor: cometEnd, stopOpacity: '0' })
            ),
            React.createElement(
              'filter',
              {
                id: id + '-blur',
                height: '3',
                width: '3',
                y: '-1',
                x: '-1',
                colorInterpolationFilters: 'sRGB'
              },
              React.createElement('feGaussianBlur', { stdDeviation: '2.5' })
            )
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Spinner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ id: uuid() });
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line no-underscore-dangle
      return React.createElement(
        ThemeConsumer,
        null,
        this._renderSpinnerWithTheme
      );
    }
  }]);

  return Spinner;
}(PureComponent);

Spinner.propTypes = {
  /** @ignore */
  t: PropTypes.func.isRequired,
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName,
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   *
   * Options:
   *
   *  - Presets:
   *    - "**primary**" (in light-theme resolves to: "blue small"; while in dark-theme resolves to: "white small");
   *  - Colors: "**blue**", "**green**", "**yellow**", "**white**";
   *  - Sizes: "**normal**", "**small**", "**tiny**";
   */
  outfit: outfitPropValidator([].concat(presetsList, colorsList, sizesList))
};
Spinner.defaultProps = {
  outfit: defaultOutfit
};


export default withTranslator(Spinner);